import React from "react";
import clsx from "clsx";
import Button from "../../../../../shared-components/css-modules/lexus/atoms/Button";
import Icon from "../../../../../shared-components/css-modules/lexus/atoms/Icon";
import styles from "./BackButton.module.scss";
import { useCarConfigSelector } from "../../../../redux/store";
import { searchModelMapValue } from "../../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import type { CommonSettingsType } from "../../../../../../../common-deprecated/settings/fetchCommonSettings";
import { APH_GRADE_SELECTOR_ID } from "../../../../../../../common-deprecated/constants";
import { CarConfigLabel } from "../../../../utils/labelUtils";
import { trackBackButton } from "../../../../utils/tracking";

export type Props = {
    sizing?: "xs" | "sm";
};

const BackButton: React.FC<Props> = ({ sizing = "sm" }) => {
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const modelId = useCarConfigSelector((state) => state.car.model.id);
    const linkToGradeSelector = searchModelMapValue<CommonSettingsType>(commonSettings, modelId)?.links?.modelPage;
    const activeSection = useCarConfigSelector((state) => state.carConfigNavigation.activeSection);

    if (!linkToGradeSelector) {
        return null;
    }

    return (
        <div className={clsx(styles.button, styles[sizing])}>
            <Button
                as="a"
                href={`${linkToGradeSelector}#${APH_GRADE_SELECTOR_ID}`}
                variant="btn-text"
                onClick={() => trackBackButton(activeSection)}
            >
                <Icon variant="arrow-left" sizing="sm" aria-hidden="true" />
                <CarConfigLabel label="carConfigBackToModelPage" />
            </Button>
        </div>
    );
};

export default BackButton;
